<div class="patient-body">
    <frg-cards class="patient-search" [ngClass]="{ 'patients-recents': displayState !== displayStateTemplate.Recherche }" title="Rechercher un patient"  [emptyIcon]="emptyIconVitale"
    (activatedEmpty)="lectureCarteVitale()" [emptyIcon1]="emptyIconAdd" (activatedEmpty1)="addPatient()">

        <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="search-form-container" *ngIf="searchForm">
            <div [ngClass]="{'expendable': !isExpendable, 'unexpendable':  isExpendable}" class="search-form-displayer">
                <frg-form-input label="Nom" id="nom" type="text" placeholder="Ex: Dupont" [formGroup]="searchForm"
                    [control]="searchForm.get('nom')" class="search-form-input" [appAutoFocus]="true" [selectOnFocus]="true">
                </frg-form-input>
                <frg-form-input label="Prénom" id="prenom" type="text" placeholder="Ex: Jean" [formGroup]="searchForm"
                    [control]="searchForm.get('prenom')" class="search-form-input" [disabled]="isNameDisabled">
                </frg-form-input>
                <div class="inline-form-input">
                    <!-- <div class="year-calendar">
                        <label for="matInput">Année de naissance</label>
                        <mat-form-field class="mat-date-field" dateFormat>
                            <input matInput [matDatepicker]="dp" formControlName="anneeNaissance" id="anneeNaissance"
                                [formGroup]="searchForm" class="search-form-input" [min]="minDate" [max]="maxDate"
                                placeholder="Ex: 1995" [disabled]="isNameDisabled">
                            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                            <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event, dp)"
                                panelClass="search-year-picker">
                            </mat-datepicker>
                        </mat-form-field>

                    </div> -->
                    <frg-form-input label="Année de naissance" id="anneeNaissance" type="fake-int-number" placeholder="ex: 1982"
                        [formGroup]="searchForm" [control]="searchForm.get('anneeNaissance')" class="search-form-input"
                        [disabled]="isNameDisabled">
                    </frg-form-input>
                    <frg-form-input label="Lieu de naissance" id="lieuNaissance" type="text" placeholder="Ville"
                        [formGroup]="searchForm" [control]="searchForm.get('lieuNaissance')" class="search-form-input"
                        [disabled]="isNameDisabled">
                    </frg-form-input>
                </div>
                <frg-form-input label="Date de naissance" id="dateNaissance" type="date"
                    placeholder="JJ/MM/AAAA" [formGroup]="searchForm" [control]="searchForm.get('dateNaissance')"
                    class="search-form-input" [minDate]="minDate" [maxDate]="maxDate">
                </frg-form-input>
                <frg-form-input label="Numéro de dossier" id="numeroDossier" type="text" placeholder="Ex: 010203"
                    [formGroup]="searchForm" [control]="searchForm.get('numeroDossier')" class="search-form-input"
                    [disabled]="isNameDisabled">
                </frg-form-input>
                <div class="inline-form-input">
                    <frg-form-input label="Inclure les dossiers archivés" id="dossierArchive" type="checkbox"
                        [formGroup]="searchForm" [control]="searchForm.get('dossierArchive')" class="search-form-input"
                        [isCheckLabelAlign]="true">
                    </frg-form-input>
                    <frg-form-input label="Activer le mode Bris de glace" id="brisDeGlace" type="checkbox"
                        [formGroup]="searchForm" [control]="searchForm.get('brisDeGlace')" class="search-form-input"
                        [isCheckLabelAlign]="true">
                    </frg-form-input>
                </div>
            </div>
            <div [ngClass]="{'expendable': isExpendable, 'unexpendable':  !isExpendable}" class="search-form-displayer">
                <frg-form-input id="recherche" type="text" placeholder="Rechercher..." [formGroup]="searchForm"
                    [control]="searchForm.get('recherche')" class="search-form-input">
                </frg-form-input>
                <div class="inline-form-input">
                    <frg-form-input label="Groupe" placeholder="Groupe" id="groupePatient" type="ngSelect"
                        [selectValue]="groupeList" [formGroup]="searchForm" [control]="searchForm.get('groupePatient')"
                        class="search-form-input">
                    </frg-form-input>
                    <frg-form-input label="Suivi par" placeholder="Suivi par" id="suiviPar" type="ngSelect"
                        [selectValue]="usersCabinet" [formGroup]="searchForm" [control]="searchForm.get('suiviPar')"
                        class="search-form-input">
                    </frg-form-input>
                </div>
                <frg-form-input label="Tag" id="tagPatient" type="colorSelect" [selectValue]="tagList"
                    [formGroup]="searchForm" [control]="searchForm.get('tagPatient')" class="search-form-input">
                </frg-form-input>
                <div class="inline-form-input">
                    <frg-form-input label="Nom" id="nomSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('nomSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                    <frg-form-input label="Nom utilisé" id="nomUsageSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('nomUsageSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                    <frg-form-input label="Nom de naissance" id="nomNaisSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('nomNaisSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                </div>
                <div class="inline-form-input">
                  <frg-form-input label="Prénom" id="prenomSpe" type="checkbox" [formGroup]="searchForm"
                    [control]="searchForm.get('prenomSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                  </frg-form-input>
                  <frg-form-input label="Prénom utilisé" id="prenomUsageSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('prenomUsageSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                    <frg-form-input label="1er Prénom de naissance" id="prenomNaisSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('prenomNaisSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                </div>
                <div class="inline-form-input">
                    <frg-form-input label="Numéro de dossier" id="numDosSpe" type="checkbox" [formGroup]="searchForm"
                        [control]="searchForm.get('numDosSpe')" class="search-form-input" [isCheckLabelAlign]="true">
                    </frg-form-input>
                    <!-- <frg-form-input label="Numéro de sécu. sociale" id="numSecuSoc" type="checkbox"
                        [formGroup]="searchForm" [control]="searchForm.get('numSecuSoc')" class="search-form-input"
                        [isCheckLabelAlign]="true">
                    </frg-form-input> -->
                </div>
                <frg-form-input label="Date de naissance" id="dateNaissance" type="date"
                    placeholder="JJ/MM/AAAA" [formGroup]="searchForm" [control]="searchForm.get('dateNaissance')"
                    class="search-form-input" [minDate]="minDate" [maxDate]="maxDate">
                </frg-form-input>
                <frg-form-input [minDate]="minDate" [maxDate]="maxDate" label="Date début suivi" id="dateDebutSuivi"
                    type="date" [formGroup]="searchForm" [control]="searchForm.get('dateDebutSuivi')"
                    class="search-form-input">
                </frg-form-input>
                <frg-form-input label="Date fin suivi" id="dateFinSuivi" type="date" [formGroup]="searchForm"
                    [control]="searchForm.get('dateFinSuivi')" class="search-form-input">
                </frg-form-input>
                <frg-form-input label="Libellé du type du suivi" id="libSuivi" type="text" [formGroup]="searchForm"
                    [control]="searchForm.get('libSuivi')" class="search-form-input">
                </frg-form-input>
                <frg-form-input label="Phonétique sur Nom et Nom de naissance" id="phonetiqueNom" type="checkbox"
                    [formGroup]="searchForm" [control]="searchForm.get('phonetiqueNom')" class="search-form-input"
                    [isCheckLabelAlign]="true">
                </frg-form-input>
                <frg-form-input label="Inclure les dossiers archivés" id="dossierArchive" type="checkbox"
                    [formGroup]="searchForm" [control]="searchForm.get('dossierArchive')" class="search-form-input"
                    [isCheckLabelAlign]="true">
                </frg-form-input>
                <div class="separator separator-top"></div>
                <div class="nir-search" *ngIf="nirSearchForm">
                    <span class="nir-wrapper">
                        <frg-form-input label="Matricule INS" id="nir" type="text" [formGroup]="nirSearchForm"
                            [control]="nirSearchForm.get('nir')" class="search-form-input nir-field">
                        </frg-form-input>
                        <frg-form-input label="Clé" id="nirKey" type="text" [formGroup]="nirSearchForm"
                            [control]="nirSearchForm.get('nirKey')" class="search-form-input nir-key-field">
                        </frg-form-input>
                    </span>
                    <div class="nir-button">
                        <frg-button
                            [disabled]="!nirSearchForm.valid"
                            (activated)="searchWithNir()"
                        >Rechercher</frg-button>
                    </div>
                </div>
                <div class="separator separator-bottom"></div>
            </div>
            <div *ngIf="isExpendable" class="more-button" (click)="expend()">
                Recherche standard
            </div>
            <div *ngIf="!isExpendable" class="more-button" (click)="expend()">
                Plus de critères de recherche
            </div>
            <!-- <div class="button-wrapper">
                    <button class="search-button" type="submit">
                        Rechercher
                    </button>
                </div> -->
        </form>
    </frg-cards>

    <!-- Affiché en temps normal -->
    <frg-cards class="patient-list" title="Liste des patients" [ngStyle]="{'width': displayState !== displayStateTemplate.Recherche ? '100%' : '68%'}">
        <div class="patient-list2"></div>
        <div class="patient-list-container">
            <div class="patient-options-button-wrapper">
                <div [ngClass]="{'active': displayState === displayStateTemplate.Recherche, 'patient-options-button': true}"
                    (click)="activateButtonPatient()">Liste des patients</div>
                <div [ngClass]="{'active': displayState === displayStateTemplate.PatientsRecents, 'patient-options-button':  true}"
                    (click)="activateButtonRecent()">Liste des patients vus récemment</div>
                <div [ngClass]="{'active': displayState === displayStateTemplate.ListeDeTravail, 'patient-options-button':  true}"
                    (click)="activateButtonListeDeTravail()">Liste de travail</div>
            </div>
            <frg-table *ngIf="displayState !== displayStateTemplate.ListeDeTravail" [loading]="isTableLoading" [keysBody]="patientList" [keysColumn]="patientColumnTable"
                [tableButton2]="useSearshOnly ? undefined : 'assets/icons/edit.svg'"
                (onClick2)="openNotePatient($event)" (onChangePage)="onChangePage($event)" (onSort)="onSort($event)"
                class="patient-table" [isRowsClickable]="true" [isOkForDblClick]="useSearshOnly ? false : true"
                (onClickRow)="useSearshOnly ? openPatient($event) : undefined" (onDblClickRow)="openPatient($event)">
            </frg-table>
            <frg-table *ngIf="displayState === displayStateTemplate.ListeDeTravail" [loading]="isTableLoading" [keysBody]="patientList" [keysColumn]="listeDeTravailColumnTable"
                tableButton2="assets/icons/red-cross.svg" tableButton2Tooltip="Supprimer ce patient de la liste de travail"
                (onClick2)="deleteElemFromListeDeTravail($event)" (onChangePage)="onChangePage($event)" (onSort)="onSort($event)"
                class="patient-table" [isRowsClickable]="true" [isOkForDblClick]="useSearshOnly ? false : true"
                (onClickRow)="useSearshOnly ? openPatient($event) : undefined" (onDblClickRow)="openPatient($event)">
            </frg-table>
            <div class="total-list" *ngIf="patientList">Nombre de patients: {{patientList.total}}
            </div>
        </div>
    </frg-cards>
</div>
